module.exports = __webpack_public_path__ + "VAGRoundedStd-Bold.1522a466a000f0094ed3.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Bold.eot
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Bold.eot
// module chunks = styles